// removed by extract-text-webpack-plugin
module.exports = {"card":"PlanetCard__card___2bf2j","featured":"PlanetCard__featured___MpnDp","card__title":"PlanetCard__card__title___25Myy","card__body":"PlanetCard__card__body___1ntZ3","card__label":"PlanetCard__card__label___3zXwr","population":"PlanetCard__population___2Nprs","climate":"PlanetCard__climate___ZMqnX","terrain":"PlanetCard__terrain___N_sXh","card__info":"PlanetCard__card__info___2u_It","info-wrapper":"PlanetCard__info-wrapper___2dRig"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanetCard/PlanetCard.scss
// module id = 55
// module chunks = 0